import styled from 'styled-components';
import { Typography } from 'modules/v2/foundation/Typography';
import { themeGet } from 'modules/v2/foundation/theme';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Title = styled(Typography) `
  margin-left: ${themeGet('spacing.md')};
`;
